import React from 'react';
import PropTypes from 'prop-types';

const Tile = ({ prefix, content, suffix }) => {
  return (
    <div className="tile">
      <div className={`tile-prefix ${prefix ? 'show' : ''}`}>{prefix}</div>
      <div>{content}</div>
      <div className={`tile-suffix ${suffix ? 'show' : ''}`}>{suffix}</div>
    </div>
  );
};

Tile.propTypes = {
  prefix: PropTypes.node,
  content: PropTypes.node.isRequired,
  suffix: PropTypes.node,
};

Tile.defaultProps = {
  prefix: null,
  suffix: null,
};

export default Tile;
